import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import {
  defaultRejectHandler, getStatusStyle,
  stringifyErrorMessage,
} from '../../utils/utility';

import {
  listACPackagedUnitInZone,
  addACPackagedUnitToZone,
  editACPackagedUnitInZone,
  removeACPackagedUnitFromZone,
} from '../../redux/zone/zone_ac_packaged_unit_actions';

import { searchACPackagedUnitByText } from '../../redux/ac_packaged_unit/ac_packaged_unit_actions';


export class ACPackagedUnitDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listAcPackagedUnit(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      zoneId,
      acPackagedUnitList,
      filteredCount,
      isLoading,
      addAcPackagedUnitToZone,
      editAcPackagedUnitInZone,
      removeACPackagedUnitFromZone,
      isAcPackagedUnitAdding,
      isAcPackagedUnitEditing,
      isAcPackagedUnitRemoving,
      errorMessage,
      t,
    } = this.props;

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    const columns = [
      {
        Header: '',
        accessor: 'air_conditioning_packaged.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'air_conditioning_packaged.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchACPackagedUnitByText(text, page, zoneId)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
        },
      },
      {
        Header: () => <b>{t('type')}</b>,
        accessor: 'air_conditioning_packaged.type',
        ...textColumn,
        width: 120,
      },
      {
        id: 'coolingCapacity',
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: row => `${row.air_conditioning_packaged.cooling_capacity} ${row.air_conditioning_packaged.unit}`,
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'air_conditioning_packaged.power_required',
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('COP')}</b>,
        accessor: 'air_conditioning_packaged.COP',
        ...coeColumn,
        width: 80,
      },
      {
        Header: () => <b>{t('SEER')}</b>,
        accessor: 'air_conditioning_packaged.SEER',
        ...coeColumn,
        width: 80,
      },
      {
        Header: () => <b>{t('compliance')}</b>,
        accessor: 'air_conditioning_packaged.compliance',
        ...coeColumn,
        width: 80,
      },
      {
        Header: () => <b>{t('status')}</b>,
        accessor: 'air_conditioning_packaged.status',
        Cell: row => <span className={getStatusStyle(row.value)}>{t(String(row.value).toLowerCase())}</span>,
        width: 70,
        ...textColumn,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...textColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    const relationship = {
      create: ({ entityId, quantity }) => addAcPackagedUnitToZone(entityId, quantity),
      edit: ({ id, quantity }) => editAcPackagedUnitInZone(id, quantity),
      delete: id => removeACPackagedUnitFromZone(id),
      isCreating: isAcPackagedUnitAdding,
      isEditing: isAcPackagedUnitEditing,
      isDeleting: isAcPackagedUnitRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={columns}
          data={acPackagedUnitList}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.air_conditioning_packaged.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  acPackagedUnitList: state.zoneACPackagedUnit.orderedIds.map(id => state.zoneACPackagedUnit.objects[id]),
  isLoading: state.zoneACPackagedUnit.isLoading,
  isAcPackagedUnitAdding: state.zoneACPackagedUnit.isCreating,
  isAcPackagedUnitEditing: state.zoneACPackagedUnit.isEditing,
  isAcPackagedUnitRemoving: state.zoneACPackagedUnit.isDeleting,
  errorMessage: state.zoneACPackagedUnit.errorMessage,
});

const mapDispatchToProps = (dispatch, ownedProps) => ({
  listAcPackagedUnit: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listACPackagedUnitInZone(pageSize, page, sorted, filtered, isPublic, ownedProps.zoneId))),
  addAcPackagedUnitToZone: (ahuId, quantity) =>
    defaultRejectHandler(dispatch(addACPackagedUnitToZone(ahuId, ownedProps.zoneId, quantity))),
  editAcPackagedUnitInZone: (id, quantity) =>
    defaultRejectHandler(dispatch(editACPackagedUnitInZone(id, quantity))),
  removeACPackagedUnitFromZone: id =>
    defaultRejectHandler(dispatch(removeACPackagedUnitFromZone(id))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ACPackagedUnitDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/ACPackagedUnitDataTable.js